/**
 * Node Modules
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'

/**
 * Application Modules
 */
import PageContainer from '../../components/page-container'
import Footer from '../../components/footer'

import Hero from '../../sections/early-access/hero'
import Metadata from '../../components/metadata'

/**
 * Page Component
 */
export default function Page({ data }) {
  const { referencePageMetadata, hed, dek, imageSlides } = data.contentfulSingletonDownloadPage

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/download/" />
        <meta property="og:url" content="https://kinzoo.com/download/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Hero hed={hed.hed} dek={dek.dek} />
      <Footer
        style={{
          '--background-color': 'var(--dark-purple)',
        }}
      />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query DownloadPageQuery {
    contentfulSingletonDownloadPage(contentful_id: { eq: "527Nr7GSYBah3Husmz3y17" }) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }
      hed {
        hed
      }
      dek {
        dek
      }
      imageSlides {
        description
        file {
          url
        }
      }
    }
  }
`
